import { gql } from "@apollo/client"

export const GET_ENTITIES_FOR_SITEMAP = gql`
  query SiteMapData {
    AllUsersTakingQuestions {
      id
      username
      updatedAt
    }
    AllQuestions {
      id
      state
      updatedAt
    }
  }
`

export const GET_APP_PREFLIGHT_DATA = gql`
  query GetAppPreflightData {
    Preflight {
      authRole
      success
      code
      publicId
      id
      name
      username
      profilePictureUrl
      email
      authRole
    }
  }
`
export const GET_USER = gql`
  query GetUser {
    User {
      ...UserOnGetUserFragment
    }
  }
`
export const USER_ON_GET_USER_FRAGMENT = gql`
  fragment UserOnGetUserFragment on User {
    name
    id
    lastSeen
    publicId
    Campaign {
      code
      type
    }
    authRole
    phoneNumber
    phoneCountryCode
    phoneVerified
    email
    emailVerified
    receiveSMSUpdates
    receivePromotionalEmailUpdates
    cashBalance
    allTimeEarnings
    stripeConnectState
    stripeSetupIntentClientSecret
    bankAccountCountry
    savePaymentMethod    
    savedPaymentMethod {
      cardType
      last4
      paymentMethodId
    }        
    answerCreatedNotificationEnabled
    questionCreatedNotificationEnabled
    questionExpirationReminderEnabled
    isTakingQuestions
  }
`
export const GET_SIGNED_PROFILE_URL = gql`
  query GetSignedUploadUrl($fileType: String!) {
    User {
      id
      signedUploadUrl(fileType: $fileType)
    }
  }
`

export const GET_STRIPE_CONNECT_STATE = gql`
  query GetStripeConnectState {
    User {
      stripeConnectState
    }
  }
`

export const GET_STRIPE_CONNECT_LOGIN_URL = gql`
  query GetStripeConnectLoginUrl {
    User {
      stripeConnectLoginUrl
    }
  }
`
export const GET_STRIPE_CONNECT_SETUP_URL = gql`
  query GetStripeConnectSetupUrl($country: String!) {
    User {
      stripeConnectSetupUrl(country: $country)
    }
  }
`
export const GET_PHONE_NUMBER_AVAILABLE = gql`
  query GetPhoneNumberAvailable($phoneCountryCode: Int!, $phoneNumber: String!) {
    PhoneNumberAvailable(phoneCountryCode: $phoneCountryCode, phoneNumber: $phoneNumber)
  }
`
export const GET_EMAIL_AVAILABLE = gql`
  query GetEmailAvailable($email: String!) {
    EmailAvailable(email: $email)
  }
`
export const GET_USERNAME_VALID = gql`
  query isUsernameValid($username: String!) {
    UsernameValid(username: $username) {
      isValid
      message
      suggestedUsername
    }
  }
`
